/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useRouter } from "next/router";

import { PlateFetcher } from "src/components/Plate/PlateFetcher";

const PageController = () => {
  const router = useRouter();
  const { username, pageSlug } = router.query as { username: string; pageSlug: string };
  return <PlateFetcher username={username} pageSlug={pageSlug} />;
};

export default PageController;
